export class Permission {
    id: number;
    name: string; // Module Name

    clear(): void {
        this.id = undefined;
        this.name = '';
    }
}
